/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * SpeakerIcon
 */
export default class SpeakerIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M20.97 15.757a1 1 0 01-.727 1.213c-.49.123-.98.234-1.47.335l-1.833 5.037a1 1 0 01-1.88-.684l1.444-3.965a33.26 33.26 0 01-9.007 0l1.443 3.965a1 1 0 01-1.88.684l-1.832-5.037c-.49-.1-.98-.212-1.47-.335a1 1 0 11.485-1.94C6.83 15.677 9.416 16 12 16c2.584 0 5.17-.323 7.757-.97a1 1 0 011.213.727zM13.364 10a4 4 0 014 4 1 1 0 01-2 0 2 2 0 00-1.851-1.995l-.15-.005h-2.727a2 2 0 00-2 2 1 1 0 01-2 0 4 4 0 013.8-3.995l.2-.005h2.728zM12 2a3.726 3.726 0 11-3.727 3.725A3.726 3.726 0 0112 2zm0 2a1.726 1.726 0 101.727 1.725C13.727 4.772 12.954 4 12 4z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

